import { render, staticRenderFns } from "./quarter-import.vue?vue&type=template&id=f2f22c8a&scoped=true&"
import script from "./quarter-import.vue?vue&type=script&lang=js&"
export * from "./quarter-import.vue?vue&type=script&lang=js&"
import style0 from "./quarter-import.vue?vue&type=style&index=0&id=f2f22c8a&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f22c8a",
  null
  
)

export default component.exports